const SUMMARY = ['summary'];

export default SUMMARY;
